/**
 * SOPs client -- talks to mttr/app_api (/api/sops). Platform users only; the
 * backend 403s everyone else. Content is markdown served from the
 * rebound-platform-docs checkout (see mttr/sops.py).
 */
import { ApiError, apiFetch } from "./apiClient";

export interface SopMeta {
  id: string;
  title: string;
  type: string;
  domain: string;
  status: string;
  last_verified: string | null;
  owner: string | null;
  contains_credentials: boolean;
}

export interface SopDoc extends SopMeta {
  body: string;
}

export class SopsApiError extends Error {
  constructor(
    message: string,
    readonly status?: number,
  ) {
    super(message);
    this.name = "SopsApiError";
  }
}

async function getJson<T>(path: string, token: string): Promise<T> {
  try {
    return await apiFetch<T>(path, token);
  } catch (e) {
    if (e instanceof ApiError) {
      // Preserve the historical "<status>: <detail>" message shape.
      const msg = e.status != null ? `${e.status}: ${e.message}` : e.message;
      throw new SopsApiError(msg, e.status);
    }
    throw e;
  }
}

export function fetchSops(token: string): Promise<{ sops: SopMeta[]; synced?: boolean }> {
  return getJson<{ sops: SopMeta[]; synced?: boolean }>("/api/sops", token);
}

export function fetchSop(id: string, token: string): Promise<SopDoc> {
  return getJson<SopDoc>(`/api/sops/${encodeURIComponent(id)}`, token);
}
